import { AssociationRoleEnum } from '@/models/Enums';

export default class AssociationUserInfo {
    public role: AssociationRoleEnum = 0;
    public id: number | null = null;
    public name: string = "";
    public associationId: number = -1;
    public associationName: string = "";
}

